module.exports = __webpack_public_path__ + "media/public/images/partners/head-d441c8f7af49c691cff9eb55c6966a20.jpg";